/**
 * Feature flags — product switches, not player overlay menus.
 * Change defaults here; wire UI later only where intentional.
 */
export const flags = {
  /** Experimental valuation: square morph (scale fills only). */
  valuationMorph: false,
  /** Show numeric eval badge with valuation. Easy to turn off later. */
  showEvalBadge: true,
  /** Awareness overlays after quiz Show (Board also requires a loaded opening). */
  awarenessOverlays: true,
  /** Multi-thread Stockfish needs COOP/COEP — off until explicitly shipped. */
  multiThreadEngine: false,
  /** Start in creator (recording) chrome. */
  creatorModeDefault: false,
} as const;

export type Flags = typeof flags;
